module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "end-intervention grid gap-2"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nom Detenteur")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.infosDet.nom_signataire),
      expression: "infosDet.nom_signataire"
    }],
    staticClass: "input",
    attrs: {
      "title": "name",
      "type": "text",
      "name": "_det_nom",
      "id": "_det_nom",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.infosDet.nom_signataire)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.infosDet, "nom_signataire", $event.target.value)
      }, _vm.updateIsValid]
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fonction")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.infosDet.fonction_signataire),
      expression: "infosDet.fonction_signataire"
    }],
    staticClass: "input",
    attrs: {
      "title": "function",
      "type": "text",
      "name": "_det_qualite",
      "id": "visa_det_qualite",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.infosDet.fonction_signataire)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.infosDet, "fonction_signataire", $event.target.value)
      }, _vm.updateIsValid]
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4e066aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/subcomponents/ClientInfos.vue
// module id = 1054
// module chunks = 0